import { createRouter, createWebHistory } from 'vue-router'

import Home from "@/views/Dashboard.vue";
import ErroInterno from "@/views/Erros/ErroInterno.vue";
import CadastroVagas from "@/views/Vagas/Cadastro.vue";
import SolicitacaoVagas from "@/views/Vagas/Solicitacao.vue";
import ListaAcessos from "@/views/Admin/AcessoUsuario.vue";
import GerenciarAcessos from "@/views/Admin/GerenciarAcessos.vue";
import ListaVagas from "@/views/Vagas/Lista.vue";
import PerfilUsuario from "@/views/Usuario/PerfilUsuario.vue";
import CadastroAtendimentos from "@/views/Atendimento/Cadastro.vue";
import ConsultaAtendimentos from "@/views/Admin/ConsultaAtendimentos.vue";
import ConsultaAgencias from "@/views/Admin/ConsultaAgencias.vue";
import { keycloakInstance } from "@/plugins/authentication.js";

const routes = [
	{ path: "/", component: Home },
	{ path: "/vagas/:id?", component: CadastroVagas },
	{ path: "/vagas/:id?/visualizar", component: SolicitacaoVagas },
	{ path: "/vagas/:id?/editar", component: SolicitacaoVagas },
	{ path: "/vagas/lista", component: ListaVagas },
	{ path: "/perfil", component: PerfilUsuario },
	// ADMIN
	{ path: "/admin/vagas/lista", component: ListaVagas },
	{ path: "/admin/vagas/:id?", component: SolicitacaoVagas },
	{ path: "/admin/gerenciar-acessos", component: ListaAcessos },
	{ path: "/admin/gerenciar-acessos/:id", component: GerenciarAcessos },
	{ path: "/admin/atendimentos/:id?", component: CadastroAtendimentos },
	{ path: "/admin/consulta-atendimentos/", component: ConsultaAtendimentos },
	{ path: "/admin/gerenciar-agencias/", component: ConsultaAgencias },
	// ERRO
	{ path: "/erro-interno", component: ErroInterno, meta: { isError: true } },
];

const router = new createRouter({
	mode: "history",
	base: "/fgtas-web/",
	history: createWebHistory("/fgtas-web/"),
	routes,
});

router.beforeEach(async (to, from, next) => {
	if (to.meta == null || to.meta.isAuthenticated == null || to.meta.isAuthenticated == true) {
		if (!keycloakInstance.authenticated) {
			keycloakInstance.login({ redirectUri: window.location.toString() });
			return;
		}
	}
	if (to.meta?.isAuthenticated == false) {
		next();
		return;
	}

	if (to.fullPath == from.fullPath && to.fullPath == "/erro-interno") {
		return;
	}

	keycloakInstance.updateToken(60)
		.then(() => {
			next();
		})
		.catch((err) => {
			console.error(err);
			keycloakInstance.logout();
		});
});

export default router;
